import { useEffect, useState } from "react";
import { useT } from "@/i18n";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { fmtDate } from "@/components/common";

export default function PublicArticleView() { const { t } = useT();
  const { token } = useParams();
  const [a, setA] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { axios.get(`${API}/public/knowledge/${token}`).then((r) => setA(r.data)).catch(() => setErr(true)); }, [token]);
  const html = (a?.body || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/^# (.*)$/gm, "<h1>$1</h1>").replace(/^## (.*)$/gm, "<h2>$1</h2>").replace(/\*\*(.+?)\*\*/g, "<b>$1</b>").replace(/^- (.*)$/gm, "<li>$1</li>").replace(/\n{2,}/g, "<br/><br/>");
  return <div className="min-h-screen bg-background"><div className="max-w-3xl mx-auto p-8" data-testid="public-article">
    {err ? <p className="text-muted-foreground">{t("lbl.this_article_is_not_available")}</p> : !a ? <p>Loading…</p> : <><div className="eyebrow">{t("lbl.orbis_knowledge")}</div><h1 className="text-3xl font-heading font-semibold mt-1" data-testid="public-article-title">{a.title}</h1><div className="text-xs text-muted-foreground mb-6">Updated {fmtDate(a.updated_at)} · {a.author}</div><div className="prose prose-sm max-w-none dark:prose-invert" dangerouslySetInnerHTML={{ __html: html }} /></>}
  </div></div>;
}
